
<slider-carousel-home *ngIf="homeBannerSlider==true"></slider-carousel-home>
<app-elearning-banner *ngIf="homeBannerSlider==false"></app-elearning-banner>

<div class="partner-area pt-100 pb-70 border-bottom">
    <div class="container">
        <app-partner></app-partner>
    </div>
</div>

<div class="partner-area pt-100 pb-70 border-bottom">
    <div class="container">
    <div class="row">
        <div class="section-title mb-5">
            <span class="sub-title">la suite DISCENTYA sempre con te</span>
            <h2>L'app Discentya per seguire i tuoi corsi ovunque vuoi</h2>
            <p>Con l'app <strong>Discentya</strong>, disponibile sia per <strong>Android</strong> che per <strong>iOS</strong>, i corsisti potranno seguire le lezioni e gestire al meglio il loro apprendimento, <strong>ovunque e in qualsiasi momento</strong>.</p>
        </div>
        <div class="col-6" align="right">
            <a href="https://apps.apple.com/it/app/discentya/id6468484981" target="_blank">
                <img src="assets/img/applestore-badge.png" style="height: 80px;">
            </a>
        </div>
        <div class="col-6">
            <a href="https://play.google.com/store/apps/details?id=com.algoritmica.discentya" target="_blank">
                <img src="assets/img/googlestore-badge.png" style="height: 80px;">
            </a>
        </div>
    </div>
    </div>
</div>

<div class="features-area pt-100 pb-70">
    <app-features-style-one></app-features-style-one>
</div>

<app-elearning-about></app-elearning-about>

<div class="courses-area ptb-100">
    <app-courses></app-courses>
</div>

<app-funfacts-feedback></app-funfacts-feedback>

<app-get-instant-courses class="d-none"></app-get-instant-courses>

<div class="blog-area ptb-100 d-none">
    <app-blog></app-blog>
</div>

<app-view-all-courses></app-view-all-courses>

<div class="premium-access-area ptb-100">
    <app-premium-access></app-premium-access>
    <div class="shape3"><img src="assets/img/shape3.png" alt="image"></div>
    <div class="shape4"><img src="assets/img/shape4.png" alt="image"></div>
    <div class="shape8"><img src="assets/img/shape7.png" alt="image"></div>
</div>
